export * from './TableTabs.tsx';
